export default "__VITE_ASSET__ByS_7lY0__"